import React, { useState, useEffect } from 'react';
import axios from 'axios';

const IndividualStockSummaryPrint = () => {
  const [reportData, setReportData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [params, setParams] = useState({});

  // Get URL parameters or props from previous page
  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const extractedParams = {
      sessionBranchId: urlParams.get('sessionBranchId') || '',
      ddl_Branch: urlParams.get('ddl_Branch') || '',
      ddl_category: urlParams.get('ddl_category') || '',
      ddl_subCategory: urlParams.get('ddl_subCategory') || '',
      ddl_innersubcategory: urlParams.get('ddl_innersubcategory') || '',
      ddl_deepinnersubcategory: urlParams.get('ddl_deepinnersubcategory') || '',
      txt_itemname: urlParams.get('txt_itemname') || '',
      txt_item: urlParams.get('txt_item') || '',
      txt_FromDate: urlParams.get('txt_FromDate') || '01/04/2022', 
      txt_ToDate: urlParams.get('txt_ToDate') || '19/08/2025',
      ddl_Stockwise: urlParams.get('ddl_Stockwise') || 'All',
      financeyearstartdate: urlParams.get('financeyearstartdate') || '25/04/2022'
    };
    setParams(extractedParams);
  }, []);

  // Sample data structure for demonstration
  const defaultReportData = {
    branchName: "Head Office",
    fromDate: "01/04/2022",
    toDate: "19/08/2025",
    itemCategory: "Not Selected",
    totalItems: 2,
    grandTotal: {
      openingQty: 0,
      openingValue: 1120000.00,
      inwardsQty: 0,
      inwardsValue: 0.00,
      outwardsQty: 3,
      outwardsValue: 1120000.00,
      closingQty: 0,
      closingValue: 0.00
    },
    items: [
      {
        sNo: 1,
        branch: "",
        itemCode: "031111001",
        itemName: "Brush cutter",
        uom: "Nos",
        openingStock: { qty: 2.00, rate: 500000.00, value: 1000000.00 },
        inwards: { qty: 0.00, rate: 0.00, value: 0.00 },
        outwards: { qty: 2.00, rate: 500000.00, value: 1000000.00 },
        closingStock: { qty: 0.00, rate: 500000.00, value: 0.00 }
      },
      {
        sNo: 2,
        branch: "Branch 8",
        itemCode: "031114004",
        itemName: "boulders machine",
        uom: "Nos",
        openingStock: { qty: 1.00, rate: 120000.00, value: 120000.00 },
        inwards: { qty: 0.00, rate: 0.00, value: 0.00 },
        outwards: { qty: 1.00, rate: 120000.00, value: 120000.00 },
        closingStock: { qty: 0.00, rate: 120000.00, value: 0.00 }
      }
    ]
  };

  // Fetch data from API
  useEffect(() => {
     const fetchReportData = async () => {
      try {
        setLoading(true);
        
        const apiUrl = `https://www.nissi-india.com/api/stock_summaryRpt`;

        console.log("params:", params);
        
        // Make POST request with axios
        const response = await axios.post(apiUrl, params, {
          headers: {
            'Content-Type': 'application/json',
          }
        });
        
        console.log("response:", response.data);
        
        // Check if API call was successful
        if (response.data && !response.data.success && response.data.success !== undefined) {
          throw new Error('API returned unsuccessful response');
        }

        // Transform API data to match component structure
         const apiData =response.data.recordset || response.data.recordsets?.[0] || [];
         console.log(apiData);

        // ✅ Transform data
        const transformedData = {
          success: response.data.success,
          Imgbtn_print_Enabled: response.data.Imgbtn_print_Enabled,
          viewHint: response.data.viewHint,
          items: apiData.map((item, index) => ({
            sNo: index + 1,
            branch: item.fld_branchname,
            itemCode: item.fld_itemcode,
            itemName: item.fld_itemname,
            uom: item.fld_uomname,

            openingStock: {
              qty: parseFloat(item.opqty || 0),
              rate: parseFloat(item.opprice || 0),
              value: parseFloat(item.opamount || 0),
            },

            inwards: {
              qty: parseFloat(
                (item.STNinwardQty || 0) +
                  (item.SRNinwardQty || 0) +
                  (item.GRNinwardQty || 0) +
                  (item.SCRinwardQty || 0)
              ),
              rate: parseFloat(
                (item.STNinwardprice || 0) +
                  (item.SRNinwardprice || 0) +
                  (item.GRNinwardprice || 0) +
                  (item.SCRinwardprice || 0)
              ),
              value: parseFloat(
                (item.STNinwardvalue || 0) +
                  (item.SRNinwardvalue || 0) +
                  (item.GRNinwardvalue || 0) +
                  (item.SCRinwardvalue || 0)
              ),
            },

            outwards: {
              qty: parseFloat(
                (item.SIoutwardQty || 0) + (item.STNoutwardQty || 0)
              ),
              rate: parseFloat(
                (item.SIoutwardprice || 0) + (item.STNoutwardprice || 0)
              ),
              value: parseFloat(
                (item.SIoutwardvalue || 0) + (item.STNoutwardvalue || 0)
              ),
            },

            closingStock: {
              qty: parseFloat(item.closingQty || 0),
              rate: parseFloat(item.closingprice || 0),
              value: parseFloat(item.closingvalue || 0),
            },
         
        
          })),
          grandTotal: {
            openingQty: apiData.reduce((sum, item) => sum + parseFloat(item.opqty|| item.opening_qty || 0), 0),
            openingValue: apiData.reduce((sum, item) => sum + parseFloat(item.opamount || item.opening_value || 0), 0),
            inwardsQty: apiData.reduce((sum, item) => sum + parseFloat(item.inwardsQty || item.inwards_qty || 0), 0),
            inwardsValue: apiData.reduce((sum, item) => sum + parseFloat(item.inwardsValue || item.inwards_value || 0), 0),
            outwardsQty: apiData.reduce((sum, item) => sum + parseFloat(item.SIoutwardQty || item.outwards_qty || 0), 0),
            outwardsValue: apiData.reduce((sum, item) => sum + parseFloat(item.outwardsValue || item.outwards_value || 0), 0),
            closingQty: apiData.reduce((sum, item) => sum + parseFloat(item.closingQty || item.closing_qty || 0), 0),
            closingValue: apiData.reduce((sum, item) => sum + parseFloat(item.closingValue || item.closing_value || 0), 0)
          }
        };

        setReportData(transformedData);
        setError(null);
        
      } catch (err) {
        console.error('Error fetching inventory stock report data:', err);
        setError(err.message);
        setReportData(defaultReportData);
      } finally {
        setLoading(false);
      }
    };

    if (Object.keys(params).length > 0) {
      fetchReportData();
    }
  }, [params]);
   

  const formatCurrency = (value) => {
    return new Intl.NumberFormat('en-IN', {
      style: 'currency',
      currency: 'INR',
      minimumFractionDigits: 2
    }).format(value).replace('₹', '₹ ');
  };

  const formatNumber = (value) => {
    return new Intl.NumberFormat('en-IN', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format(value);
  };

  if (loading) {
    return (
      <div className="max-w-full mx-auto p-6 bg-white font-sans text-sm">
        <div className="flex items-center justify-center h-64">
          <div className="text-center">
            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto mb-4"></div>
            <p className="text-gray-600">Loading inventory stock report data...</p>
          </div>
        </div>
      </div>
    );
  }

  if (!reportData) {
    return (
      <div className="max-w-full mx-auto p-6 bg-white font-sans text-sm">
        <div className="flex items-center justify-center h-64">
          <div className="text-center text-red-600">
            <p className="text-lg font-semibold mb-2">Error Loading Report</p>
            <p>{error || "Failed to load inventory stock report data"}</p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="max-w-full mx-auto p-6 bg-white font-sans text-sm">
      {/* API Error Warning */}
      {error && (
        <div className="mb-4 p-3 bg-yellow-100 border border-yellow-400 text-yellow-700 rounded no-print">
          <p className="text-sm">
            <strong>Note:</strong> Using sample data for demonstration. ({error})
          </p>
        </div>
      )}

      {/* Outer Border */}
      <div className="border-4 border-black p-4 print:border-black">
        
        {/* Header Section */}
        <div className="border-2 border-black mb-4 print:border-black">
          <div className="flex items-start p-4">
            {/* Logo Section */}
            <div className="w-32 h-20 border-2 border-black mr-6 flex items-center justify-center bg-white">
              <div className="text-center">
                <div className="w-12 h-8 bg-black mx-auto mb-1 flex items-center justify-center">
                  <span className="text-white text-xs font-bold">LOGO</span>
                </div>
                <div className="text-xs font-bold">NISSI INFOTECH</div>
                <div className="text-xs">PVT LTD</div>
              </div>
            </div>
            
            {/* Company Info */}
            <div className="flex-1 text-center">
              <h1 className="text-xl font-bold mb-1">Nissi Infotech</h1>
              <p className="text-sm mb-1">NISSI</p>
              <p className="text-sm font-bold mb-1">CIVIL CONSTRUCTION</p>
              <p className="text-xs">
                3/42-12, Nagappa colony, kavundampai,644003,Tamil Nadu,India,<br/>
                Phone No :9003744644 infraconsoft-implementation@nissiinfotech.in
              </p>
            </div>

            {/* Screen Info */}
            <div className="text-right text-xs">
              <p>INFRA SCREEN : A-59/2</p>
            </div>
          </div>
        </div>

        {/* Report Parameters */}
        <div className="grid grid-cols-3 gap-4 mb-4 text-sm">
          <div>
            <span className="font-bold">Item Category:</span> {reportData.itemCategory}
          </div>
          <div>
            <span className="font-bold">From Date:</span> {reportData.fromDate}
          </div>
          <div>
            <span className="font-bold">To Date:</span> {reportData.toDate}
          </div>
        </div>

        {/* Main Table */}
        <div className="border-2 border-black mb-4 print:border-black overflow-x-auto">
          <table className="w-full text-xs">
            <thead>
              <tr className="bg-gray-100 print:bg-white">
                <th className="border border-black px-2 py-2 text-center print:border-black">Sino</th>
                <th className="border border-black px-2 py-2 text-center print:border-black">Branch</th>
                <th className="border border-black px-2 py-2 text-center print:border-black">Item Code</th>
                <th className="border border-black px-2 py-2 text-center print:border-black">Item Name</th>
                <th className="border border-black px-2 py-2 text-center print:border-black">UOM</th>
                
                {/* Opening Stock */}
                <th className="border border-black px-2 py-2 text-center print:border-black" colSpan="3">Opening Stock</th>
                
                {/* Inwards */}
                <th className="border border-black px-2 py-2 text-center print:border-black" colSpan="3">Inwards</th>
                
                {/* Outwards */}
                <th className="border border-black px-2 py-2 text-center print:border-black" colSpan="3">Outwards</th>
                
                {/* Closing Stock */}
                <th className="border border-black px-2 py-2 text-center print:border-black" colSpan="3">Closing Stock</th>
              </tr>
              <tr className="bg-gray-50 print:bg-white">
                <th className="border border-black px-2 py-1 text-center print:border-black"></th>
                <th className="border border-black px-2 py-1 text-center print:border-black"></th>
                <th className="border border-black px-2 py-1 text-center print:border-black"></th>
                <th className="border border-black px-2 py-1 text-center print:border-black"></th>
                <th className="border border-black px-2 py-1 text-center print:border-black"></th>
                
                <th className="border border-black px-1 py-1 text-center print:border-black">Qty</th>
                <th className="border border-black px-1 py-1 text-center print:border-black">Rate</th>
                <th className="border border-black px-1 py-1 text-center print:border-black">Value</th>
                
                <th className="border border-black px-1 py-1 text-center print:border-black">Qty</th>
                <th className="border border-black px-1 py-1 text-center print:border-black">Rate</th>
                <th className="border border-black px-1 py-1 text-center print:border-black">Value</th>
                
                <th className="border border-black px-1 py-1 text-center print:border-black">Qty</th>
                <th className="border border-black px-1 py-1 text-center print:border-black">Rate</th>
                <th className="border border-black px-1 py-1 text-center print:border-black">Value</th>
                
                <th className="border border-black px-1 py-1 text-center print:border-black">Qty</th>
                <th className="border border-black px-1 py-1 text-center print:border-black">Rate</th>
                <th className="border border-black px-1 py-1 text-center print:border-black">Value</th>
              </tr>
            </thead>
            <tbody>
              {reportData.items.map((item) => (
                <tr key={item.sNo}>
                  <td className="border border-black px-2 py-1 text-center print:border-black">{item.sNo}</td>
                  <td className="border border-black px-2 py-1 text-center print:border-black">{item.branch}</td>
                  <td className="border border-black px-2 py-1 text-center print:border-black">{item.itemCode}</td>
                  <td className="border border-black px-2 py-1 text-left print:border-black">{item.itemName}</td>
                  <td className="border border-black px-2 py-1 text-center print:border-black">{item.uom}</td>
                  
                  {/* Opening Stock */}
                  <td className="border border-black px-1 py-1 text-right print:border-black">{formatNumber(item.openingStock.qty)}</td>
                  <td className="border border-black px-1 py-1 text-right print:border-black">{formatCurrency(item.openingStock.rate)}</td>
                  <td className="border border-black px-1 py-1 text-right print:border-black">{formatCurrency(item.openingStock.value)}</td>
                  
                  {/* Inwards */}
                  <td className="border border-black px-1 py-1 text-right print:border-black">{formatNumber(item.inwards.qty)}</td>
                  <td className="border border-black px-1 py-1 text-right print:border-black">{formatCurrency(item.inwards.rate)}</td>
                  <td className="border border-black px-1 py-1 text-right print:border-black">{formatCurrency(item.inwards.value)}</td>
                  
                  {/* Outwards */}
                  <td className="border border-black px-1 py-1 text-right print:border-black">{formatNumber(item.outwards.qty)}</td>
                  <td className="border border-black px-1 py-1 text-right print:border-black">{formatCurrency(item.outwards.rate)}</td>
                  <td className="border border-black px-1 py-1 text-right print:border-black">{formatCurrency(item.outwards.value)}</td>
                  
                  {/* Closing Stock */}
                  <td className="border border-black px-1 py-1 text-right print:border-black">{formatNumber(item.closingStock.qty)}</td>
                  <td className="border border-black px-1 py-1 text-right print:border-black">{formatCurrency(item.closingStock.rate)}</td>
                  <td className="border border-black px-1 py-1 text-right print:border-black">{formatCurrency(item.closingStock.value)}</td>
                </tr>
              ))}

              {/* Total Row */}
              <tr className="bg-gray-100 print:bg-white font-bold">
                <td className="border border-black px-2 py-1 text-center print:border-black" colSpan="5">Total:</td>
                <td className="border border-black px-1 py-1 text-right print:border-black">{formatNumber(reportData.grandTotal.openingQty)}</td>
                <td className="border border-black px-1 py-1 text-right print:border-black"></td>
                <td className="border border-black px-1 py-1 text-right print:border-black">{formatCurrency(reportData.grandTotal.openingValue)}</td>
                <td className="border border-black px-1 py-1 text-right print:border-black">{formatNumber(reportData.grandTotal.inwardsQty)}</td>
                <td className="border border-black px-1 py-1 text-right print:border-black"></td>
                <td className="border border-black px-1 py-1 text-right print:border-black">{formatCurrency(reportData.grandTotal.inwardsValue)}</td>
                <td className="border border-black px-1 py-1 text-right print:border-black">{formatNumber(reportData.grandTotal.outwardsQty)}</td>
                <td className="border border-black px-1 py-1 text-right print:border-black"></td>
                <td className="border border-black px-1 py-1 text-right print:border-black">{formatCurrency(reportData.grandTotal.outwardsValue)}</td>
                <td className="border border-black px-1 py-1 text-right print:border-black">{formatNumber(reportData.grandTotal.closingQty)}</td>
                <td className="border border-black px-1 py-1 text-right print:border-black"></td>
                <td className="border border-black px-1 py-1 text-right print:border-black">{formatCurrency(reportData.grandTotal.closingValue)}</td>
              </tr>

              {/* No Data Message */}
              {reportData.items.length === 0 && (
                <tr>
                  <td className="border border-black px-2 py-8 text-center print:border-black" colSpan="17">
                    <div className="text-gray-500">
                      No inventory records found for the specified criteria
                    </div>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        {/* Footer */}
        <div className="border-2 border-black print:border-black">
          <div className="p-2 text-right text-xs">
            <span className="font-bold">Page 1 of 1</span>
          </div>
          <div className="border-t-2 border-black p-2 text-xs print:border-black">
            Report generated by ERP-Software - www.infraconsoft.com owned by <span className="font-bold">www.nissiinfotech.com</span>
          </div>
        </div>

      </div>

      {/* Control Buttons */}
      <div className="mt-6 text-center no-print">
        <button
          onClick={() => window.print()}
          className="bg-blue-600 text-white px-6 py-2 rounded hover:bg-blue-700 transition-colors mr-4"
        >
          Print Report
        </button>
        <button
          onClick={() => window.location.reload()}
          className="bg-gray-600 text-white px-6 py-2 rounded hover:bg-gray-700 transition-colors mr-4"
        >
          Refresh Data
        </button>
        <button
          onClick={() => window.close()}
          className="bg-red-600 text-white px-6 py-2 rounded hover:red-700 transition-colors"
        >
          Close Window
        </button>
      </div>

      {/* Print Styles */}
      <style jsx>{`
        @media print {
          .no-print {
            display: none !important;
          }
          body {
            margin: 0;
            padding: 10mm;
            background: white !important;
          }
          * {
            color: black !important;
            background: white !important;
            border-color: black !important;
          }
          .print\\:border-black {
            border-color: black !important;
          }
          .print\\:bg-white {
            background-color: white !important;
          }
          table {
            font-size: 7px !important;
          }
          .text-green-600 {
            color: black !important;
          }
        }
      `}</style>
    </div>
  );
};

export default IndividualStockSummaryPrint;